module.exports = __webpack_public_path__ + "img/fa5b8b032b58ae82f9775f8da62636bd.fd11c0ab.png";